import THGTracker from '../../tracking/thg/THGTracker';
import Experiments from './experiments';
import JsonHelper from './jsonHelper';
import Nonce from './nonce';
import Performance from './performance';
import Request from './request';

function onLoad(callback) {
  // Wait until next tick
  const callbackDeferred = () => {
    setTimeout(callback, 0);
  };
  
  // Already loaded?
  if (document.readyState === 'complete') {
    callbackDeferred();
  } else if (window.addEventListener) {
    window.addEventListener('load', callbackDeferred, false);
  }
}

class Chase {
  sendPerformanceStats(serverUrl) {
    // Run when loaded
    onLoad(() => {
      const jsonMessage = JsonHelper.getJsonMessage(
        Request.getRequestData(),
        Experiments.getExperimentsData(),
        Performance.getPerformanceStats(window.performance),
        Nonce.getNonce(),
      );
      
      THGTracker.sendPerformance(serverUrl, jsonMessage);
    });
  }
  
  init(settings) {
    const trackingEnabled = settings.checkout_tracking_enabled;
    const trackingUrl = settings.checkout_tracking_url;
    
    if (trackingEnabled && trackingUrl) {
      this.sendPerformanceStats(trackingUrl);
    }
  }
}

export default new Chase();
